// appointment log tags
export const LT_AP_SB = 'AP/SB';
export const LT_AP_WZ = 'AP/WZ';

// transaction log tags
export const LT_CHECKOUT = '#TX/CHECKOUT';
export const LT_DEPOSIT = '#TX/DEPOSIT';

//
export const LT_FETCH = '#FETCH';
export const LT_POS = '#POSLOG';
export const LT_PUSHER = '#PUSHER';
export const LT_RDX = '#REDUX';
export const LT_ROUTE = '#ROUTE';
export const LT_SCHEDULER_DAY = '#SCHEDAY';
export const LT_URL = '#URL';
